import React from 'react';
import DocumentationSidebar from '../component/DocumentationSidebar';
import Searchbar from '../component/SearchBar';
import image001 from '../assetes/images/settings/puppeteer-settings-img/image001.png';
import image002 from '../assetes/images/settings/puppeteer-settings-img/image002.png';

export default function PuppeteerSettings() {
    return (
        <>
            <div className='d-flex flex-column main-outer-wrapper'>
                <div className="flex-grow-1 d-flex survey-main-wrapper">
                    <DocumentationSidebar />

                    {/* Dashboard Content */}
                    <div className="flex-grow-1 dashboard-page-outer">
                        <div className='dashboard-page-wrap document-page-wrap'>
                            <Searchbar containerSelector=".search-scope" />
                            <div className='search-scope mt-4'>
                                <h1 className='mt-0 text-primary'>Puppeteer Settings</h1>
                                <p>This section allows administrators to configure the file path for the Puppeteer Chrome executable used in the system for headless browser automation.</p>

                                <div className="card dashboard-card mb-4">
                                    <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                                        Accessing Puppeteer Settings
                                    </div>
                                    <div className="card-body">

                                        <ul>
                                            <img src={image001} alt="fullview" className='img-fluid pt-10 pb-20' />
                                            <li>Navigate to the Settings menu in the sidebar.</li>
                                            <li>Click on Puppeteer Settings under the GENERAL section.</li>
                                        </ul>

                                    </div>
                                </div>

                                <div className="card dashboard-card mb-4">
                                    <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                                        Puppeteer Settings Configuration
                                    </div>
                                    <div className="card-body">
                                        <img src={image002} alt="fullview" className='pt-10 pb-20' />
                                        <ul>
                                            <li><b>Input Field - </b> Text box to specify the path to the Puppeteer Chrome executable. This is used by the application for automated browser tasks (e.g., PDF generation, scraping).</li>
                                            <li><b>Example Path - </b> /home/ubuntu/.cache/puppeteer/chrome/linux-121.0.6167.85/chrome-linux64/chrome — represents a Linux-based Puppeteer Chrome binary.</li>
                                            <li><b>Save Changes Button - </b> A red button that saves the updated path configuration. On clicking, the changes are stored and used by the application.</li>
                                        </ul>

                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}
